import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { useRoute, useRouter } from 'vue-router/composables'
import { IBattle, ICrew, IGroupCrews, IGroupParticipants, IParticipant } from '@/types/battle'
import { computed, onMounted, ref } from 'vue'
import api from '@/api'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import BKInput from '@/components/AppShared/BKInput.vue'
import { mdiMagnify, mdiPlus } from '@mdi/js'
import { BKConfirmationDialog } from '@/shared/ui/modals'
import { IEvent } from '@/enitites/event'

interface IProps {
  battle: IBattle
  groupsList: IGroupCrews[] | IGroupParticipants[] | []
  event: IEvent
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PrelimsGroups',
  props: {
    battle: null,
    groupsList: null,
    event: null
  },
  setup(__props: any) {

const props = __props as {
  battle: IBattle
  groupsList: IGroupCrews[] | IGroupParticipants[] | []
  event: IEvent
};

const { getAvatar } = useImage()
const router = useRouter()
const route = useRoute()



const confirmationDialog = ref({
  isShow: false,
  title: '',
  subtitle: '',
  confirmText: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  confirm: () => {},
})

const sortBy = ref('')
const prelims = ref<Record<string, unknown>[] | null>(null)
const loading = ref(false)
const searchText = ref('')
const filteredGroups = computed(() => {
  if (!props.groupsList) return []
  // eslint-disable-next-line array-callback-return,consistent-return
  return props.groupsList.filter((group) => {
    if (group.participants) {
      return group.participants.some((participant: IParticipant) =>
        participant.name.toLowerCase().includes(searchText.value.toLowerCase())
      )
    }

    if (group.crews) {
      return group.crews.some((participant: ICrew) =>
        participant.name.toLowerCase().includes(searchText.value.toLowerCase())
      )
    }
  })
})

async function finishPrelims() {
  loading.value = true

  const updatedPrelims = await api.prelims.finishPrelims(props.battle.id)
  loading.value = false
  if (!updatedPrelims) return
  prelims.value = updatedPrelims
  router.push({ query: { prelimsViewMode: 'list' } })
}

async function fetchPrelims() {
  const prelimsData = await api.prelims.getPrelims(route.params.id, sortBy.value)
  if (!prelimsData) {
    store.commit('setIsNotFound', true)
    return
  }

  prelims.value = prelimsData
}

function openGroup(groupId: string): void {
  router.push({ name: 'Group', params: { groupId } })
}

async function undoBrackets() {
  loading.value = true
  await api.prelims.undoBrackets(props.battle.id)
  await fetchPrelims()
  loading.value = false
}

function showUndoBracketsConfirmationDialog() {
  confirmationDialog.value = {
    isShow: true,
    title: 'Undo brackets',
    subtitle: `Are you sure you want to undo brackets?`,
    confirmText: 'Undo',
    confirm: () => {
      undoBrackets()
      confirmationDialog.value.isShow = false
    },
  }
}

function showAddToBracketsConfirmationDialog() {
  confirmationDialog.value = {
    isShow: true,
    title: 'Add to bracket',
    subtitle: `Are you sure you want to add to brackets?`,
    confirmText: 'Add',
    confirm: () => {
      finishPrelims()
      confirmationDialog.value.isShow = false
    },
  }
}

onMounted(() => {
  fetchPrelims()
})

return { __sfc: true,getAvatar, router, route, props, confirmationDialog, sortBy, prelims, loading, searchText, filteredGroups, finishPrelims, fetchPrelims, openGroup, undoBrackets, showUndoBracketsConfirmationDialog, showAddToBracketsConfirmationDialog, BKInput, mdiMagnify, mdiPlus, BKConfirmationDialog }
}

})